module.exports = __webpack_public_path__ + "static/b1-e9ca4a8f64e47cdf4ead4cc0f19182d6.png";